/*

File handles all api calls for Groups

*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'

var BuildingGroups = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getBuildingGroups: function(context) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "buildings/groups";
		var object = this;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			context.setState({ data: response.data });
		})
		.fail(function(e){
			console.log(e);
		});
	},
	getBuildingGroupsCallback: function(callback) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "buildings/groups";
		var object = this;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			callback(response.data);
		})
		.fail(function(e){
			console.log(e);
			callback(false);
		});
	}
});

export let buildingGroups = new BuildingGroups();


// WEBPACK FOOTER //
// app/core/controllers/BuildingGroups.js